export default __webpack_public_path__ + "static/media/figureOne.30ddd5ac.svg";